import Auth0 from '@ibiquity/dashboard.auth0';

const auth0 = new Auth0({
  id: process.env.VUE_APP_AUTH0_CLIENT_ID,
  domain: process.env.VUE_APP_AUTH0_CLIENT_DOMAIN,
});

export default auth0;
